import React, { useEffect, useMemo, useRef, useState } from "react";

import axios from "axios";
import base_url from "../../api/bootapi";
import debounce from "lodash.debounce";
import SearchIcon from "@mui/icons-material/Search";
import "../flightWeather/flightWeather.css";
import { AcUnit } from "@mui/icons-material";
import { Loader } from "@mantine/core";
import Nav from "../../components/nav/Nav";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ReactComponent as SmallCrossIcon } from "../../assets/fi-rr-cross-small.svg";
import DelayTable from "./DelayTable";
import Footer from "../../components/footer/Footer";
import { DatePicker } from "@mantine/dates";
import moment from "moment/moment";
import "./delayStatistics.css";
import NewDelayStatistics from "./NewDelayStatistics";

const DelayStatistics = () => {
  const [loading, setLoading] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [airport, setAirport] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [iata, setIata] = useState("");
  const [airportName, setAirportName] = useState("");

  const [dateUpdated, setDateUpdated] = useState(false);

   const [dateRange, setDateRange] = useState([
    moment().startOf("day").toDate(), // Today 00:00
    moment().endOf("day").toDate(),   // Today 23:59
  ]);

  const [airportWeatherData, setAirportWeatherData] = useState(null);
  console.log(airportWeatherData);
  const debouncedLoadOptions = useMemo(
    () =>
      debounce((value, callback) => {
        loadOptions(value, callback);
      }, 200),
    []
  );

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/airport_list?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            name: airport.name,
            shortName: airport.shortName,
            municipalityName: airport.municipalityName,
            iata: airport.iata,
            timeZone: airport.timeZone,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };

  useEffect(() => {
    if (dateUpdated) {
      fetchWeather(true);
    }
  }, [dateUpdated]);

  const fetchWeather = async (fromDateRange = false) => {
    if (!airport) {
      return;
    }

    setLoading(true);

    console.log(dateRange);
    // const formatted = dateRange.map((date) =>
    //   date ? moment(date).format("YYYY-MM-DDTHH:mm") : null
    // );

    
   
    let formatedDate = dateRange
      ? moment(dateRange).format("YYYY-MM-DDTHH:mm")
      : null;

    let url = null;
    if (dateRange[0] && dateRange[1]) {
      // if (formatted[0] === formatted[1]) {
      const from = moment(dateRange[0]).startOf('day').format("YYYY-MM-DDTHH:mm")
      const to = moment(dateRange[1]).endOf('day').format("YYYY-MM-DDTHH:mm")
      url = `${base_url.api1}/tourapp/airport_delays?iata=${iata}&from=${from}&to=${to}`;
      // }

      // else {
      //   url = `${base_url.api1}/tourapp/airport_delays?iata=${iata}&from=${formatted[0]}&to=${formatted[1]}`;
      // }
    } else {
      url = `${base_url.api1}/tourapp/airport_delays?iata=${iata}`;
    }

    try {
      const response = await axios.get(url);

      console.log(response.data.data);
      setLoading(false);

      // setAirportWeatherData(response.data.data);
      setAirportWeatherData([].concat(response?.data?.data ?? []));
      setAirportName(airport.name);
      if (dateUpdated) {
        setDateUpdated(false);
      }
    } catch (error) {
      setAirportWeatherData(null);
      if (dateRange) {
        setDateRange([
    moment().startOf("day").toDate(), // Today 00:00
    moment().endOf("day").toDate(),   // Today 23:59
  ]);
      }
      if (dateUpdated) {
        setDateUpdated(false);
      }
      console.error("Error fetching airports:", error);
      setLoading(false);
    }
  };

  const handleCross = () => {
    setAirport("");
    setIata("");
    setTimeZone("");
    setAirportWeatherData(null);
    setDateRange([
    moment().startOf("day").toDate(), // Today 00:00
    moment().endOf("day").toDate(),   // Today 23:59
  ]);
  };

  return (
    <div>
      <Nav />

      <div className="weather-wrapper">
        <h2
          className="header"
          style={{ textAlign: "center", marginBottom: "50px" }}
        >
          Airport Delay Statistics
        </h2>

        <div className="weather-dropdown">
          <SearchIcon />

          <input
            type="text"
            placeholder="Search airports"
            className="airportInput"
            autoFocus
            value={airport}
            onChange={(e) => {
              const inputValue = e.target.value;

              setAirport(inputValue);
              debouncedLoadOptions(inputValue, (options) => {
                setDefaultOptions(options);
              });
            }}
          />
          {airport && <SmallCrossIcon onClick={() => handleCross()} />}
          {defaultOptions.length > 0 && (
            <div className="search-flight-list">
              {defaultOptions.length > 0 ? (
                defaultOptions.map((option, i) => (
                  <span
                    className="flight-dropdown-item"
                    key={i}
                    onClick={(e) => {
                      e.stopPropagation();
                      setAirport(option.name);
                      setTimeZone(option.timeZone);
                      setIata(option.iata);
                      setDefaultOptions([]);
                    }}
                  >
                    {option.name}{" "}
                    <span className="iata_code">({option.iata})</span>
                  </span>
                ))
              ) : (
                <span
                  style={{
                    padding: "10px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  No matching locations found
                </span>
              )}
            </div>
          )}
          <button className="check-weather-btn" onClick={fetchWeather}>
            Search
          </button>
        </div>

        <div className="weather-listing-wrapper statistics-listing">
          {loading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Loading...
              <Loader color="blue" />
            </div>
          )}

           {((!loading && !airportWeatherData) || airportWeatherData?.length === 0)  && (
            <div style={{ textAlign: "center" }}>No Data Found</div>
          )}
          {!loading && airport && airportWeatherData?.length > 0 && (
            <div className="weather-list-listt">
              {/* <DelayTable
                data={airportWeatherData}
                dateRange={dateRange}
                setDateRange={setDateRange}
                setDateUpdated={setDateUpdated}
              /> */}

              <NewDelayStatistics apiData={airportWeatherData} dateRange={dateRange} setDateRange={setDateRange} setDateUpdated={setDateUpdated}/>
            </div>
          )}
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default DelayStatistics;
